import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = { class: "topCon" }
const _hoisted_4 = { class: "topConR" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "nav-menu" }

import { useRouter } from 'vue-router';
import { userInfo, logout } from '@/api/index'
import { ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'

// 获取 router 实例

export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderView',
  setup(__props) {

const router = useRouter();

const goLogin = () => {
    router.push('/order');
};

let userName = ref()
let avatar = ref('')

// 获取用户信息
userInfo().then(res => {
    userName.value = res.data.nickname
    avatar.value = res.data.avatar
})

// 退出登录
const loginOut = () => {
    ElMessageBox.confirm(
        '你确定要退出登录吗？',
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            logout().then(res => {
                console.log(res)
                ElMessage.success("操作成功！")
                userName.value = ""
                avatar.value = ""
                localStorage.removeItem('token')
            }).catch(err => {
                console.log(err)
            })
        })
        .catch(() => {
            ElMessage({
                type: 'info',
                message: '已取消',
            })
        })
}

const goHome = () => {
    router.push('/');
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", { class: "topConLeft" }, [
          _createElementVNode("img", {
            onClick: goHome,
            class: "toplogoimg",
            src: _imports_0,
            alt: ""
          }),
          _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"topConLefts\" data-v-a0fce06c></div><div class=\"topConLeftText\" data-v-a0fce06c>优质冻品 · 专业批发 · 品质之选 · 一站式供应链</div><div class=\"phoneMail\" data-v-a0fce06c><div class=\"pubs\" data-v-a0fce06c><img class=\"imgs\" src=\"https://pic.qianxizhenxuan.com/qianxizx/qbwfile/202609/20260901/%E7%94%B5%E8%AF%9D-c391e727906d41fa9d29e7c0378702ca.png\" alt=\"\" srcset=\"\" data-v-a0fce06c><div data-v-a0fce06c>客服电话：15638280025</div></div><div class=\"pubs\" data-v-a0fce06c><img class=\"imgs\" src=\"https://pic.qianxizhenxuan.com/qianxizx/qbwfile/202609/20260901/%E9%82%AE%E7%AE%B1-59d9b20f46d64c6cab3bfa4ca9c21fa8.png\" alt=\"\" srcset=\"\" data-v-a0fce06c><div data-v-a0fce06c>客服邮箱：15638280025@163.com</div></div></div>", 3))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            onClick: goLogin,
            style: {"margin-right":"10px"}
          }, "我的订单"),
          (_unref(avatar))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("img", {
                  style: {"width":"36px","height":"36px","border-radius":"50%","margin-left":"10px"},
                  src: _unref(avatar),
                  alt: ""
                }, null, 8, _hoisted_6)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            style: {"margin-left":"5px","margin-right":"20px"},
            onClick: goLogin
          }, _toDisplayString(_unref(userName) ? _unref(userName) : '登录'), 1),
          (_unref(userName))
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                onClick: loginOut
              }, "退出"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("nav", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: "/home",
          "active-class": "active",
          exact: ""
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("首页", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/products",
          "active-class": "active"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("主营产品", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/about",
          "active-class": "active"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("关于我们", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})